//
// MapConnectionInfo.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../resources/network/URL";
import "./MapProviderVersion";
import "../resources/network/AuthDelegate";

var MapConnectionInfo = createModule("commons::MapConnectionInfo", [], EventDispatcher, [
    {
        ESRI_PORTAL_TOKEN_UPDATED: 10027,
        ESRI_PREMIUM_TOKEN_UPDATED: 10028,
        ESRI_ALL_TOKENS_UPDATED: 10029,
    },
    ,
    ,
    {
        esriPortalUrl: 7,
        regionEndpoint: 1,
        authDelegate: 1,
        esriPremiumToken: 7,
        localEsriServicesUrl: 7,
        esriPortalRequiresAuthentication: 2,
        localEsriHomeUrl: 7,
        version: 4,
        esriPortalToken: 7,
        localEsriServicesSsoAppId: 7,
    },
    ,
    {
        _create: [4,7,4],
    },
    ,
]);
export default MapConnectionInfo;
